/** Shared shape for any `{ value, label }` enum entry served by the API. */
export type TemplateFieldTypePayload = {
	readonly value: string;
	readonly label: string;
};

export type TemplateFieldTypesFetchedPayload = TemplateFieldTypePayload[];

export type TemplateFieldTypesFetchedAction = {
	type: 'TEMPLATE_FIELD_TYPES_FETCHED';
	payload: TemplateFieldTypesFetchedPayload;
};

export default (payload: TemplateFieldTypesFetchedPayload): TemplateFieldTypesFetchedAction => ({
	type: 'TEMPLATE_FIELD_TYPES_FETCHED',
	payload,
});
